// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var BestEnrollmentType;
(function (BestEnrollmentType) {
    BestEnrollmentType["Enrolled"] = "Active";
    BestEnrollmentType["Queued"] = "Pending";
    BestEnrollmentType["Rejected"] = "Rejected";
})(BestEnrollmentType || (BestEnrollmentType = {}));
//# sourceMappingURL=bestEnrollmentType.js.map